import { IAppAction } from "../../classes/action";
import { ActionType } from "./actiontype";

export function setToDesktop(): IAppAction {
    return {
        type: ActionType.TRANSITION_DESKTOP
    }
}

export function setToMobile(): IAppAction {
    return {
        type: ActionType.TRANSITION_MOBILE
    }
}